import { useNavigate } from 'react-router';
import { Icons } from '@/components/icons';

const STEPS = [
  { icon: Icons.Camera, title: '1. Capture', body: 'Take a clear photo of the full receipt. Flat, well-lit, all edges visible.' },
  { icon: Icons.Sparkle, title: '2. We extract', body: 'Our vision model reads the store, items, quantities, prices, tax and total.' },
  { icon: Icons.Check, title: '3. You confirm', body: 'Review the parsed data, fix anything off, assign categories, and save.' },
];

export function NewExpenseRoute() {
  const navigate = useNavigate();

  return (
    <div style={{ maxWidth: 720 }}>
      <div className="card" style={{ marginBottom: 14 }}>
        <div className="card-h">
          <h3>Add a receipt</h3>
          <span className="sub">Snap a photo or enter it by hand</span>
        </div>
        <div style={{ padding: 18 }}>
          <div className="upload">
            <Icons.Camera size={28} stroke="var(--primary)" sw={1.4} />
            <div className="ttl">Snap or upload receipt</div>
            <div className="hint">
              We'll auto-extract the store, items, prices and totals from a photo of your receipt.
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
              <button className="btn primary" onClick={(e) => { e.stopPropagation(); navigate('/expenses/new/scan'); }}>
                <Icons.Upload size={14} /> Scan a receipt
              </button>
            </div>
            <div className="or">— or —</div>
            <button className="btn ghost sm" onClick={(e) => { e.stopPropagation(); navigate('/expenses/new/manual'); }}>
              Enter manually
            </button>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-h">
          <h3>How it works</h3>
        </div>
        <div className="how-grid" style={{ padding: '0 18px 18px' }}>
          {STEPS.map((s) => {
            const Ic = s.icon;
            return (
              <div key={s.title} style={{ padding: 14, background: 'var(--bg-2)', borderRadius: 10 }}>
                <Ic size={18} stroke="var(--primary)" />
                <div style={{ fontFamily: 'var(--font-display)', fontSize: 15, fontWeight: 500, marginTop: 8 }}>{s.title}</div>
                <div style={{ fontSize: 12.5, color: 'var(--muted)', marginTop: 4 }}>{s.body}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
